module.exports = __webpack_public_path__ + "img/ti_logo.cd0f33a7.png";